<template>
                    
                           
<section class="forgot-password" :style="{
    'background-image': 'url(' + backgroundImage + ')'
  }">
  <header-logged-out :type="type" :checkuser="false"></header-logged-out>
  <v-container fill-height>
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card>
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>{{ label }} Password Reset</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <transition name="slide-y-transition" mode="out-in">
            <section v-if="!credChosen" class="enter-creds" key="enterCreds">
              <v-card-text>
                <p>
                  {{ formLabel }}
                </p>
                <section v-if="type === 'student'">
                  <class-code title="Student code" v-model="cred" v-validate="'required|min:4'" data-vv-name="class_code" data-vv-as="student code" hint="The student code must be supplied to you by a teacher" data-vv-validate-on="change" :error-messages="errors.collect('class_code')"></class-code>
                </section>
                <section v-else>
                  <v-text-field v-model="cred" v-validate="'required|max:150'" :error-messages="errors.collect('cred')" label="Enter your email" data-vv-name="cred" data-vv-as="email" required></v-text-field>
                </section>
              </v-card-text>
              <v-card-actions class="px-3 pb-3 pt-0">
                <template>
                  <router-link :to="`/${type}/login`" style="color: #1565c0">
                    Back to login.
                  </router-link>
                </template>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submit" :loading="loading" :disabled="loading">
                  Submit
                </v-btn>
              </v-card-actions>
            </section>
            <section v-else class="choose-class" key="chooseClass">
              <v-card-text>
                <form v-if="teachers.length > 0 && cred">
                  <label class="choose-class">
                    Choose a teacher to ask to reset your password:
                  </label>
                  <v-radio-group v-model="teacher" column>
                    <v-radio v-for="t in teachers" :key="t.teacher_id" :label="t.teacher_name" :value="t.teacher_id"></v-radio>
                  </v-radio-group>
                  <p>
                    We will send them a message and they will reset your
                    password and let you know when your new password is ready.
                  </p>
                </form>
                <div v-else>
                  No teacher found
                </div>
              </v-card-text>
              <v-card-actions class="px-3 pb-3 pt-0">
                <div>
                  <a href="javascript:void(0)" @click="credChosen = false" style="color: #1565c0">
                    Try another username.
                  </a>
                </div>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!teachers.length" @click="submit" :loading="loading">
                  Notify my teacher
                </v-btn>
              </v-card-actions>
            </section>
          </transition>
        </v-card>
      </v-col>
    </v-row>
    <custom-snackbar></custom-snackbar>
  </v-container>
</section>

                         
                  </template> 
                  <script >
import Individual from '@/modules/individual/models/Individual'
import ForgotPassword from '@/modules/auth/views/ForgotPassword'

export default {
  name: 'IndividualForgotPassword',
  extends: ForgotPassword,
  data() {
    return {
      type: 'user',
      label: '',
      formLabel: 'Enter the email for which you want the password reset.'
    }
  },
  computed: {
    backgroundImage() {
      return this.bucketUrl + '/assets/background_landing-page.jpg'
    }
  },
  methods: {
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        let form = {
          email: this.cred
        }
        this.loading = true

        await Individual.dispatch('forgotPassword', {
          payload: form,
          axios: this.$axios
        })
        this.loading = false
        this.showSnackbar('We have emailed you with the reset password link')
        this.cred = ''
      } catch (error) {
        this.$setErrorsFromResponse(error.response.data)
        this.loading = false
      }
    }
  }
}
</script>